import React from 'react'


import Box from '@material-ui/core/Box';
import Styles from "./footer.module.css";
import Grid from '@material-ui/core/Grid';




const footer = () => {
    return (
        <Box className={Styles.footer}>
           

                <h3 className={Styles.text}>Develope By Hasintha Diyaneth</h3>
                <p className={Styles.text}> ©2021 👨 All Rights Reserved.</p>
           
        </Box>
    )
}

export default footer
